<template>
	<v-card outlined>
		<v-card-title class="pb-2">Marche</v-card-title>
		<v-card-text class="pb-0">
			<v-text-field v-model="cerca" label="Cerca marca" outlined dense hide-details append-icon="mdi-magnify"></v-text-field>
			<v-switch v-model="soloConUrl" color="primary" dense hide-details label="Solo marche con sito" class="mt-2"></v-switch>
		</v-card-text>
		<v-list dense class="lista">
			<v-list-item-group :value="selectedId" color="primary">
				<v-list-item v-for="b in filtrate" :key="b._id" :value="b._id" @click="$emit('select', b._id)">
					<v-list-item-content>
						<v-list-item-title>{{ b.name || '(senza nome)' }}</v-list-item-title>
						<v-list-item-subtitle>{{ b.url || 'nessun sito impostato' }}</v-list-item-subtitle>
					</v-list-item-content>
					<v-list-item-action class="align-end">
						<v-chip x-small :color="stato(b).colore" outlined>{{ stato(b).testo }}</v-chip>
						<span v-if="daValutare(b)" class="caption mt-1">{{ daValutare(b) }} da valutare</span>
					</v-list-item-action>
				</v-list-item>
			</v-list-item-group>
			<v-list-item v-if="filtrate.length === 0">
				<v-list-item-content class="grey--text">Nessuna marca</v-list-item-content>
			</v-list-item>
		</v-list>
	</v-card>
</template>

<script>
import { attivo } from './testi';

export default {
	name: 'BrandImportBrandList',
	props: {
		brands: { type: Array, default: () => [] },
		selectedId: { type: String, default: null },
	},
	data() {
		return { cerca: '', soloConUrl: false };
	},
	computed: {
		filtrate() {
			const q = this.cerca.trim().toLowerCase();
			return this.brands.filter(b => (!q || (b.name || '').toLowerCase().includes(q)) && (!this.soloConUrl || b.url || (b.config && (b.config.baseUrl || b.config.sitemapUrl))));
		},
	},
	methods: {
		daValutare(b) {
			return (b.counts.new || 0) + (b.counts.updated || 0);
		},
		stato(b) {
			if (attivo(b.lastJob)) return { testo: 'In corso', colore: 'primary' };
			const cfg = b.config || {};
			if (cfg.status === 'blocked') return { testo: 'Bloccata', colore: 'error' };
			if (cfg.status === 'requires_browser') return { testo: 'Serve browser', colore: 'warning' };
			if (b.brokenRules && !b.activeRules) return { testo: 'Regole da rivedere', colore: 'warning' };
			if (b.activeRules) return { testo: `Regole v${b.activeRules.version}`, colore: 'success' };
			if (b.draftRules) return { testo: 'Regole in bozza', colore: 'warning' };
			return { testo: 'Da configurare', colore: 'grey' };
		},
	},
};
</script>

<style scoped>
.lista {
	max-height: 65vh;
	overflow-y: auto;
}
</style>
